(() => {
  const configNode = document.getElementById('rok-pilot-pack-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = document.querySelector('main');
  if (!root) return;
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.currency});
  const unitMoney = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.currency, minimumFractionDigits: 4, maximumFractionDigits: 4});
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const selected = () => {
    const input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    return config.variants.find(v => v.id === input?.value);
  };
  let scheduled = false;
  const observer = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; update(); }); } });
  function watch() { observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id']}); }
  function update() {
    observer.disconnect();
    const variant = selected();
    const grid = root.querySelector('#bold_qb_grid');
    if (grid) {
      grid.hidden = !variant?.tiered || grid.dataset.variantId !== variant.id;
      const priceBlock = root.querySelector('.wt-product__info > [id^="price-"]');
      if (priceBlock && priceBlock.nextElementSibling !== grid) priceBlock.after(grid);
      if (!grid.hidden && !grid.querySelector('table') && config.overflowVariant?.id === variant.id) {
        const source = config.overflowVariant;
        try {
          const rules = typeof source.rules === 'string' ? JSON.parse(source.rules) : source.rules;
          const entries = rules?.tags?.[source.group] || rules?.tags?.default || [];
          const tiers = new Map([[1, Number(source.base)]]);
          for (const entry of entries) {
            const [qty, type, price] = entry.split(',');
            if (type === '$' && Number(qty) >= 1 && Number.isFinite(Number(price))) tiers.set(Number(qty), Number(price));
          }
          if (tiers.size > 1) {
            const fallbackTable = document.createElement('table');
            const head = fallbackTable.createTHead().insertRow();
            head.append(document.createElement('th'), document.createElement('th'));
            const body = fallbackTable.createTBody();
            for (const [qty, price] of [...tiers].sort((a, b) => a[0] - b[0])) {
              const row = body.insertRow();
              row.insertCell().textContent = String(qty);
              row.insertCell().textContent = money.format(price);
            }
            grid.append(fallbackTable);
          }
        } catch (_) {}
      }
      const table = grid.querySelector('table');
      if (!grid.hidden && table) {
        const rows = [...table.querySelectorAll('tbody tr')];
        const tiers = rows.map(row => ({qty: Number(row.cells[0]?.dataset.threshold || row.cells[0]?.textContent.trim().match(/^\d+/)?.[0]), price: Number(row.cells[1]?.textContent.replace(/[^\d.]/g, ''))}));
        // Scope account/quantity price updates to this product's price block.
        if (tiers.length && tiers.every(t => t.qty > 0 && Number.isFinite(t.price))) {
          const quantity = Math.max(1, Number(root.querySelector('form[action*="/cart/add"] input[name="quantity"]')?.value || root.querySelector('input[name="quantity"]')?.value || 1));
          const currentTier = tiers.filter(t => t.qty <= quantity).sort((a, b) => b.qty - a.qty)[0];
          const currentPrice = priceBlock?.querySelector('.rok-price-display__sale .wt-product__price__final');
          if (currentTier && currentPrice) setText(currentPrice, money.format(currentTier.price));
        }
        const signature = JSON.stringify([variant.id, tiers]);
        if (table.dataset.rokPackSignature === signature) { watch(); return; }
        if (tiers.length && tiers.every(t => t.qty > 0 && Number.isFinite(t.price))) {
          table.dataset.rokPackSignature = signature;
          let message = grid.querySelector('.rok-tier-message');
          if (!message) { message = document.createElement('p'); message.className = 'rok-tier-message'; grid.prepend(message); }
          const firstSaving = tiers.find(t => t.qty > 1 && t.price < tiers[0].price);
          message.hidden = !firstSaving;
          setText(message, firstSaving ? (variant.eachUnit ? config.labels.eachMessage : config.labels.packMessage).replace('[qty]', firstSaving.qty).replace('[price]', money.format(firstSaving.price)).replace('[saving]', money.format(tiers[0].price - firstSaving.price)) : '');
          let caption = table.querySelector('caption');
          if (!caption) { caption = document.createElement('caption'); table.prepend(caption); }
          setText(caption, (variant.eachUnit ? config.labels.eachCaption : variant.setUnit ? config.labels.setCaption : config.labels.caption).replace('[count]', variant.pack));
          const header = table.querySelector('thead tr');
          const labels = variant.eachUnit ? [config.labels.eachQuantity, config.labels.eachPrice, config.labels.eachSave] : [config.labels.quantity, config.labels.price, variant.setUnit ? config.labels.setUnit : config.labels.unit, config.labels.save];
          while (header.cells.length < labels.length) header.append(document.createElement('th'));
          while (header.cells.length > labels.length) header.lastElementChild.remove();
          labels.forEach((label, i) => { setText(header.cells[i], label); if (header.cells[i].scope !== 'col') header.cells[i].scope = 'col'; });
          rows.forEach((row, i) => {
            const tier = tiers[i];
            if (row.cells[0].dataset.threshold !== String(tier.qty)) row.cells[0].dataset.threshold = tier.qty;
            setText(row.cells[0], tiers[i + 1] ? `${tier.qty}–${tiers[i + 1].qty - 1}` : `${tier.qty}+`);
            while (row.cells.length < labels.length) row.append(document.createElement('td'));
            while (row.cells.length > labels.length) row.lastElementChild.remove();
            if (!variant.eachUnit) setText(row.cells[2], unitMoney.format(tier.price / variant.pack));
            setText(row.cells[variant.eachUnit ? 2 : 3], money.format(Math.max(0, tiers[0].price - tier.price)));
          });
        }
      }
    }
    watch();
  }
  root.addEventListener('variantChangeStart', () => { const grid = root.querySelector('#bold_qb_grid'); if (grid) grid.hidden = true; });
  root.addEventListener('variantChangeEnd', update);
  root.addEventListener('change', update);
  update();
})();

